import { render } from "./HistoryAbout.vue?vue&type=template&id=57569e20&scoped=true"
import script from "./HistoryAbout.vue?vue&type=script&lang=js"
export * from "./HistoryAbout.vue?vue&type=script&lang=js"

import "./HistoryAbout.vue?vue&type=style&index=0&id=57569e20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57569e20"]])

export default __exports__